import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f749c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-hidden"]

import { computed, ref, onMounted, onBeforeUnmount, nextTick } from 'vue';

const TOOLTIP_MIN_WIDTH = 280;
const EDGE_OFFSET = 80;


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoPopover',
  props: {
    label: {},
    positionBottom: { type: Boolean }
  },
  setup(__props: any) {



const isHovered = ref(false);
const isClicked = ref(false);
const remainingSpace = ref({ left: 0, right: 0 });

const tooltip =
	ref(); /** The HTML element ref, used to get position on screen and calculate left and right */

const computedPositionLeft = computed(() => {
	if (remainingSpace.value.left <= 0) return '0px';

	if (remainingSpace.value.left <= TOOLTIP_MIN_WIDTH / 2)
		return `-${remainingSpace.value.left}px`;

	return '';
});

const computedPositionRight = computed(() => {
	if (remainingSpace.value.right <= 0) return '0px';

	if (remainingSpace.value.right <= TOOLTIP_MIN_WIDTH / 2)
		return `-${remainingSpace.value.right}px`;

	return `calc(50% - ${TOOLTIP_MIN_WIDTH / 2}px`;
});

const getRemainingSpace = () => {
	const windowWidth = window?.innerWidth || 0;

	remainingSpace.value.left = tooltip.value?.getBoundingClientRect().left - EDGE_OFFSET;
	remainingSpace.value.right =
		windowWidth - tooltip.value?.getBoundingClientRect().right - EDGE_OFFSET;
};

const onClickOutside = () => {
	if (isClicked.value) isClicked.value = false;
};

onMounted(async () => {
	window.addEventListener('resize', getRemainingSpace);
	await nextTick();
	getRemainingSpace();
});

onBeforeUnmount(() => {
	window.removeEventListener('resize', getRemainingSpace);
});

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "info-tooltip",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = true)),
    onMouseout: _cache[2] || (_cache[2] = ($event: any) => (isHovered.value = false))
  }, [
    _createElementVNode("button", {
      class: _normalizeClass([['bx', isHovered.value || isClicked.value ? 'bxs-info-circle' : ' bx-info-circle'], "info-tooltip__button"]),
      ref_key: "tooltip",
      ref: tooltip,
      type: "button",
      tabindex: "0",
      "aria-label": _ctx.label,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isClicked.value = !isClicked.value), ["stop"]))
    }, null, 10, _hoisted_1),
    (isHovered.value || isClicked.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          role: "tooltip",
          "aria-hidden": isHovered.value || isClicked.value,
          style: _normalizeStyle({ left: computedPositionLeft.value, right: computedPositionRight.value }),
          class: _normalizeClass([
				'info-tooltip__label',
				{
					'info-tooltip__label--bottom': _ctx.positionBottom,
				},
			])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ], 14, _hoisted_2))
      : _createCommentVNode("", true)
  ], 32)), [
    [_directive_click_outside, onClickOutside]
  ])
}
}

})